const en: Record<string, string> = {
  'features.recipes.empty': 'No recipes yet. Add one to get started.',
  'features.recipes.newRecipe': 'New recipe',
  'features.recipes.name': 'Name',
  'features.recipes.namePlaceholder': 'e.g. Lasagna',
  'features.recipes.servings': 'Servings',
  'features.recipes.servingsCount': '{{count}} servings',
  'features.recipes.description': 'Description',
  'features.recipes.labels': 'Labels',
  'features.recipes.newLabel': 'New label',
  'features.recipes.configureLabels': 'Configure labels',
  'features.recipes.doneConfiguringLabels': 'Done configuring labels',
  'features.recipes.ingredients': 'Ingredients',
  'features.recipes.noIngredients': 'No ingredients yet.',
  'features.recipes.addIngredient': 'Add ingredient',
  'features.recipes.removeIngredient': 'Remove ingredient',
  'features.recipes.moveIngredientUp': 'Move up',
  'features.recipes.moveIngredientDown': 'Move down',
  'features.recipes.ingredientSearchLabel': 'Ingredient',
  'features.recipes.searchIngredientPlaceholder': 'Search an ingredient…',
  'features.recipes.noFoodSections': 'No food sections in the catalog yet.',
  'features.recipes.noCatalogMatch': 'No catalog item matches "{{query}}".',
  'features.recipes.addToCatalogAction': 'Add "{{query}}" to the catalog',
  'features.recipes.addToCatalogHelp': 'It will be created in the shared groceries catalog, in the aisle chosen below.',
  'features.recipes.notInCatalogAction': "This ingredient won't be in the catalog",
  'features.recipes.notInCatalogHelp': 'Used only for this recipe — not saved to the shared groceries catalog.',
  'features.recipes.customIngredientName': 'Ingredient name',
  'features.recipes.customIngredientUnit': 'Unit',
  'features.recipes.customIngredientSection': 'Aisle',
  'features.recipes.customIngredientSectionPlaceholder': 'No aisle (optional)',
  'features.recipes.changeIngredient': 'Change',
  'features.recipes.quantity': 'Quantity',
  'features.recipes.displayOverride': 'Custom text',
  'features.recipes.displayOverridePlaceholder': 'e.g. a pinch',
  'features.recipes.isAccompaniment': 'This is an accompaniment',
  'features.recipes.isAccompanimentHelp': "Not part of the recipe itself, but suggested alongside it (e.g. bread with a soup). Added to a groceries list one at a time, not with the recipe's core ingredients.",
  'features.recipes.accompaniments': 'Accompaniments',
  'features.recipes.condiments': 'Condiments',
  'features.recipes.add': 'Add',
  'features.recipes.create': 'Create',
  'features.recipes.cancel': 'Cancel',
  'features.recipes.back': 'Back',
  'features.recipes.backToList': 'Back to recipes',
  'features.recipes.readMode': 'Read mode',
  'features.recipes.editRecipe': 'Edit recipe',
  'features.recipes.state.draft': 'Draft',
  'features.recipes.state.completed': 'Completed',
  'features.recipes.markCompleted': 'Mark as completed',
  'features.recipes.searchPlaceholder': 'Search a recipe or an ingredient…',
  'features.recipes.ingredientFilterPlaceholder': 'Filter by ingredient',
  'features.recipes.difficulty.label': 'Difficulty',
  'features.recipes.difficulty.level0': 'Very easy',
  'features.recipes.difficulty.level1': 'Easy',
  'features.recipes.difficulty.level2': 'Moderate',
  'features.recipes.difficulty.level3': 'Intermediate',
  'features.recipes.difficulty.level4': 'Hard',
  'features.recipes.difficulty.level5': 'Very hard',
  'features.recipes.clearDifficultyFilter': 'Clear',
  'features.recipes.prepTime': 'Prep time',
  'features.recipes.totalTime': 'Total time',
  'features.recipes.prepTimeValue': 'Prep: {{time}}',
  'features.recipes.totalTimeValue': 'Total: {{time}}',
  'features.recipes.minutesShort': '{{count}} min',
  'features.recipes.hoursShort': '{{count}}h',
  'features.recipes.hoursMinutesShort': '{{hours}}h{{minutes}}',
  'features.recipes.components': 'Components',
  'features.recipes.addComponent': 'Add a component',
  'features.recipes.removeComponent': 'Remove component',
  'features.recipes.componentRecipe': 'Recipe',
  'features.recipes.selectComponentRecipe': 'Select a recipe…',
  'features.recipes.multiplier': 'Multiplier',
  'features.recipes.multiplierHelp': 'How many times to use this recipe (e.g. 2 for a double batch).',
  'features.recipes.componentMultiplier': '×{{multiplier}}',
};

export default en;
